import { render, staticRenderFns } from "./BackToResult.vue?vue&type=template&id=fc94452c&"
import script from "./BackToResult.vue?vue&type=script&lang=js&"
export * from "./BackToResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports